import { render, staticRenderFns } from "./InquiryPartner.vue?vue&type=template&id=4c8b8d6f&"
import script from "./InquiryPartner.vue?vue&type=script&lang=js&"
export * from "./InquiryPartner.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports